var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    !_vm.detalleVehiculoHomeRendered
      ? _c(
          "div",
          { attrs: { id: "drawerDivSetup" } },
          [
            _vm.drawer
              ? _c(
                  "div",
                  [
                    _c(
                      "v-navigation-drawer",
                      {
                        attrs: {
                          "mini-variant": _vm.miniVariant,
                          clipped: _vm.clipped,
                          width: 327,
                          app: ""
                        },
                        model: {
                          value: _vm.drawer,
                          callback: function($$v) {
                            _vm.drawer = $$v
                          },
                          expression: "drawer"
                        }
                      },
                      [
                        _c("v-divider"),
                        _c(
                          "v-list",
                          [
                            _c(
                              "v-list",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: false,
                                    expression: "false"
                                  }
                                ]
                              },
                              [
                                _c(
                                  "v-list-tile",
                                  [
                                    _c(
                                      "v-list-tile-title",
                                      {
                                        staticStyle: {
                                          cursor: "pointer",
                                          "font-size": "13px"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n                Home\n              "
                                        )
                                      ]
                                    ),
                                    _c(
                                      "v-list-tile-action",
                                      [_c("v-icon", [_vm._v("home")])],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._l(_vm.aplicaciones, function(item) {
                              return _c(
                                "v-list-group",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: item.visible,
                                      expression: "item.visible"
                                    }
                                  ],
                                  key: item.title,
                                  attrs: { "no-action": "", value: true },
                                  model: {
                                    value: item.active,
                                    callback: function($$v) {
                                      _vm.$set(item, "active", $$v)
                                    },
                                    expression: "item.active"
                                  }
                                },
                                [
                                  [
                                    _c(
                                      "v-list-tile",
                                      {
                                        attrs: {
                                          slot: "activator",
                                          avatar: ""
                                        },
                                        slot: "activator"
                                      },
                                      [
                                        _c(
                                          "v-list-tile-title",
                                          {
                                            staticStyle: {
                                              cursor: "pointer",
                                              "font-size": "13px"
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "\n                  " +
                                                _vm._s(item.title) +
                                                "\n                "
                                            )
                                          ]
                                        ),
                                        _c(
                                          "v-list-tile-action",
                                          [
                                            _c("v-icon", [
                                              _vm._v(_vm._s(item.action))
                                            ])
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  _vm.tieneHijos(item.items)
                                    ? _c(
                                        "div",
                                        _vm._l(item.items, function(subItem) {
                                          return _c(
                                            "v-list-group",
                                            {
                                              directives: [
                                                {
                                                  name: "show",
                                                  rawName: "v-show",
                                                  value:
                                                    subItem.visible &&
                                                    !(
                                                      subItem.title ===
                                                        "Informes" &&
                                                      _vm.clienteId !== 2735
                                                    ),
                                                  expression:
                                                    "\n                  subItem.visible &&\n                    !(subItem.title === 'Informes' && clienteId !== 2735)\n                "
                                                }
                                              ],
                                              key: subItem.title,
                                              attrs: {
                                                right: "",
                                                "sub-group": "",
                                                "no-action": ""
                                              }
                                            },
                                            [
                                              [
                                                _c(
                                                  "v-list-tile",
                                                  {
                                                    attrs: {
                                                      slot: "activator"
                                                    },
                                                    slot: "activator"
                                                  },
                                                  [
                                                    _c(
                                                      "v-list-tile-title",
                                                      {
                                                        staticStyle: {
                                                          cursor: "pointer",
                                                          "font-size": "13px"
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                      " +
                                                            _vm._s(
                                                              subItem.title
                                                            ) +
                                                            "\n                    "
                                                        )
                                                      ]
                                                    ),
                                                    _c(
                                                      "v-list-tile-action",
                                                      [
                                                        _c("v-icon", [
                                                          _vm._v(
                                                            _vm._s(
                                                              subItem.action
                                                            )
                                                          )
                                                        ])
                                                      ],
                                                      1
                                                    )
                                                  ],
                                                  1
                                                )
                                              ],
                                              _vm._l(subItem.items, function(
                                                subItem2
                                              ) {
                                                return _c(
                                                  "v-list-tile",
                                                  {
                                                    directives: [
                                                      {
                                                        name: "show",
                                                        rawName: "v-show",
                                                        value: subItem2.visible,
                                                        expression:
                                                          "subItem2.visible"
                                                      }
                                                    ],
                                                    key: subItem2.title
                                                  },
                                                  [
                                                    _c(
                                                      "v-list-tile-content",
                                                      [
                                                        _c(
                                                          "v-list-tile-title",
                                                          {
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                return _vm.selectComponent(
                                                                  subItem2.path
                                                                )
                                                              }
                                                            }
                                                          },
                                                          [
                                                            subItem2.path.startsWith(
                                                              "/"
                                                            )
                                                              ? _c(
                                                                  "router-link",
                                                                  {
                                                                    staticStyle: {
                                                                      cursor:
                                                                        "pointer",
                                                                      "font-size":
                                                                        "13px"
                                                                    },
                                                                    attrs: {
                                                                      tag: "li",
                                                                      "active-class":
                                                                        "router-link-active",
                                                                      to:
                                                                        subItem2.path
                                                                    }
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        subItem2.title
                                                                      )
                                                                    )
                                                                  ]
                                                                )
                                                              : _c(
                                                                  "a",
                                                                  {
                                                                    staticClass:
                                                                      "vinculo-externo",
                                                                    attrs: {
                                                                      href:
                                                                        subItem2.path,
                                                                      target:
                                                                        "_blank"
                                                                    }
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        subItem2.title
                                                                      )
                                                                    )
                                                                  ]
                                                                )
                                                          ],
                                                          1
                                                        )
                                                      ],
                                                      1
                                                    ),
                                                    _c(
                                                      "v-list-tile-action",
                                                      [
                                                        _c("v-icon", [
                                                          _vm._v(
                                                            _vm._s(
                                                              subItem2.action
                                                            )
                                                          )
                                                        ])
                                                      ],
                                                      1
                                                    )
                                                  ],
                                                  1
                                                )
                                              })
                                            ],
                                            2
                                          )
                                        }),
                                        1
                                      )
                                    : _vm._l(item.items, function(subItem) {
                                        return _c(
                                          "div",
                                          { key: subItem.title },
                                          _vm._l(subItem.items, function(
                                            subItem2
                                          ) {
                                            return _c(
                                              "v-list-tile",
                                              {
                                                directives: [
                                                  {
                                                    name: "show",
                                                    rawName: "v-show",
                                                    value: subItem2.visible,
                                                    expression:
                                                      "subItem2.visible"
                                                  }
                                                ],
                                                key: subItem2.title
                                              },
                                              [
                                                _c(
                                                  "v-list-tile-content",
                                                  [
                                                    _c(
                                                      "v-list-tile-title",
                                                      {
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            return _vm.selectComponent(
                                                              subItem2.path
                                                            )
                                                          }
                                                        }
                                                      },
                                                      [
                                                        subItem2.path.startsWith(
                                                          "/"
                                                        )
                                                          ? _c(
                                                              "router-link",
                                                              {
                                                                staticStyle: {
                                                                  cursor:
                                                                    "pointer",
                                                                  "font-size":
                                                                    "13px"
                                                                },
                                                                attrs: {
                                                                  tag: "li",
                                                                  "active-class":
                                                                    "router-link-active",
                                                                  to:
                                                                    subItem2.path
                                                                }
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    subItem2.title
                                                                  )
                                                                )
                                                              ]
                                                            )
                                                          : _c(
                                                              "a",
                                                              {
                                                                staticClass:
                                                                  "vinculo-externo",
                                                                attrs: {
                                                                  href:
                                                                    subItem2.path,
                                                                  target:
                                                                    "_blank"
                                                                }
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    subItem2.title
                                                                  )
                                                                )
                                                              ]
                                                            )
                                                      ],
                                                      1
                                                    )
                                                  ],
                                                  1
                                                ),
                                                _c(
                                                  "v-list-tile-action",
                                                  [
                                                    _c("v-icon", [
                                                      _vm._v(
                                                        _vm._s(subItem2.action)
                                                      )
                                                    ])
                                                  ],
                                                  1
                                                )
                                              ],
                                              1
                                            )
                                          }),
                                          1
                                        )
                                      })
                                ],
                                2
                              )
                            })
                          ],
                          2
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              : _c(
                  "div",
                  [
                    _c(
                      "v-navigation-drawer",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.drawer == false,
                            expression: "drawer == false"
                          }
                        ],
                        staticStyle: { background: "transparent" },
                        attrs: {
                          clipped: _vm.clipped,
                          app: "",
                          width: 55,
                          "max-width": "40",
                          "min-width": "40"
                        },
                        model: {
                          value: _vm.drawerfloat,
                          callback: function($$v) {
                            _vm.drawerfloat = $$v
                          },
                          expression: "drawerfloat"
                        }
                      },
                      [
                        _c(
                          "v-toolbar",
                          {
                            staticStyle: { background: "transparent" },
                            attrs: { flat: "" }
                          },
                          [
                            [
                              _c(
                                "v-list",
                                {
                                  staticStyle: {
                                    "background-color": "transparent"
                                  }
                                },
                                _vm._l(_vm.aplicaciones, function(item) {
                                  return _c(
                                    "v-list-tile",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: item.visible,
                                          expression: "item.visible"
                                        }
                                      ],
                                      key: item.title
                                    },
                                    [
                                      _c(
                                        "v-list-tile-action",
                                        {
                                          staticStyle: {
                                            "background-color": "transparent"
                                          }
                                        },
                                        [
                                          _c(
                                            "v-btn",
                                            {
                                              staticStyle: {
                                                "background-color":
                                                  "transparent",
                                                border: "none",
                                                "margin-left": "-38px"
                                              },
                                              attrs: { outline: "" },
                                              on: {
                                                click: function($event) {
                                                  ;(_vm.drawer = true),
                                                    (_vm.drawerfloat = false)
                                                }
                                              }
                                            },
                                            [
                                              _c(
                                                "v-icon",
                                                { attrs: { color: "#606060" } },
                                                [_vm._v(_vm._s(item.action))]
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                }),
                                1
                              )
                            ]
                          ],
                          2
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
            _c(
              "v-toolbar",
              {
                staticClass: "color-header-bar",
                attrs: { dark: "", app: "", "clipped-left": _vm.clipped }
              },
              [
                _c("v-toolbar-side-icon", {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.showSideBar,
                      expression: "showSideBar"
                    }
                  ],
                  on: {
                    click: function($event) {
                      $event.stopPropagation()
                      ;(_vm.drawer = !_vm.drawer),
                        (_vm.drawerfloat = !_vm.drawerfloat)
                    }
                  }
                }),
                _vm._v("  \n      "),
                _c("div", {
                  staticClass: "logo-sidebar",
                  attrs: { title: "Ir al Inicio" },
                  on: {
                    click: function($event) {
                      return _vm.goToHome()
                    }
                  }
                }),
                _vm._v("\n\n             \n      "),
                _c(
                  "v-flex",
                  { attrs: { xs6: "", sm6: "", lg4: "", "d-flex": "" } },
                  [
                    _vm.showSideBar
                      ? _c(
                          "div",
                          [
                            _c("v-autocomplete", {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.mostrarClientes,
                                  expression: "mostrarClientes"
                                }
                              ],
                              staticClass: "sidebar-item",
                              staticStyle: { "padding-top": "23px" },
                              attrs: {
                                "item-value": "id",
                                "item-text": "nombre",
                                "input-class": ["color-input"],
                                "no-data-text": "Sin resultados",
                                items: _vm.clientes,
                                color: "dark",
                                label: ""
                              },
                              on: {
                                change: _vm.changeCliente,
                                blur: _vm.validaCliente
                              },
                              model: {
                                value: _vm.selectedCliente,
                                callback: function($$v) {
                                  _vm.selectedCliente = $$v
                                },
                                expression: "selectedCliente"
                              }
                            })
                          ],
                          1
                        )
                      : _c("div", [_vm._v(_vm._s(_vm.nombreCliente))])
                  ]
                ),
                _c("v-spacer"),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.showSideBar,
                        expression: "showSideBar"
                      }
                    ]
                  },
                  [
                    _c(
                      "v-btn",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.mostrarAlertas,
                            expression: "mostrarAlertas"
                          }
                        ],
                        attrs: { fab: "", small: "", color: "transparent" },
                        on: {
                          click: function($event) {
                            return _vm.showModalNotificacionesAlertas()
                          }
                        }
                      },
                      [
                        _c(
                          "v-badge",
                          {
                            staticClass: "badge-sidebar",
                            attrs: { overlap: "" }
                          },
                          [
                            _vm.muestraNumero
                              ? _c(
                                  "span",
                                  {
                                    staticStyle: {
                                      color: "black",
                                      "font-size": "12px",
                                      "font-weight": "bold"
                                    },
                                    attrs: { slot: "badge" },
                                    slot: "badge"
                                  },
                                  [_vm._v(_vm._s(_vm.numeroNotificaciones))]
                                )
                              : _vm._e(),
                            _c(
                              "v-icon",
                              {
                                staticClass: "color-header-bar",
                                attrs: { medium: "" }
                              },
                              [_vm._v("notifications")]
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v("\n           \n      "),
                _vm.showSideBar
                  ? _c(
                      "div",
                      { staticClass: "text-xs-center" },
                      [
                        _c(
                          "v-menu",
                          {
                            attrs: {
                              "offset-y": "",
                              "close-on-content-click": false
                            }
                          },
                          [
                            _c(
                              "v-btn",
                              {
                                staticClass: "color-header-bar",
                                attrs: {
                                  slot: "activator",
                                  "data-testid": "SideBar__v-btn--usuario",
                                  depressed: true
                                },
                                slot: "activator"
                              },
                              [
                                _c("v-icon", [_vm._v("account_circle")]),
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.currentUser) +
                                    "  \n            "
                                ),
                                _c("v-icon", [_vm._v("keyboard_arrow_down")])
                              ],
                              1
                            ),
                            _c(
                              "v-list",
                              [
                                _c(
                                  "v-list-tile",
                                  [
                                    _c(
                                      "v-list-tile-title",
                                      {
                                        staticStyle: { cursor: "pointer" },
                                        on: {
                                          click: function($event) {
                                            return _vm.goToMiPerfil()
                                          }
                                        }
                                      },
                                      [
                                        _c("v-icon", [_vm._v("person")]),
                                        _vm._v("  Mi Perfil\n              ")
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _vm.valideSubDomain
                                  ? _c(
                                      "v-list-tile",
                                      [
                                        _c(
                                          "v-list-tile-title",
                                          {
                                            staticStyle: { cursor: "pointer" },
                                            on: {
                                              click: function($event) {
                                                return _vm.eventoEjecutivo()
                                              }
                                            }
                                          },
                                          [
                                            _c("v-icon", [
                                              _vm._v("assignment_ind")
                                            ]),
                                            _vm._v(
                                              "  Contacto Ejecutivo\n              "
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _c(
                                  "v-list-tile",
                                  [
                                    _c(
                                      "v-list-tile-title",
                                      {
                                        staticStyle: { cursor: "pointer" },
                                        on: {
                                          click: function($event) {
                                            _vm.logoutDialog = true
                                          }
                                        }
                                      },
                                      [
                                        _c("v-icon", [_vm._v("streetview")]),
                                        _vm._v(
                                          "  Cerrar Sesión\n              "
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  : _vm.showSideBar == true && _vm.isMobile == "mobile"
                  ? _c(
                      "div",
                      [
                        _c(
                          "v-btn",
                          {
                            attrs: {
                              slot: "activator",
                              color: "primary",
                              dark: "",
                              depressed: true
                            },
                            slot: "activator"
                          },
                          [
                            _c(
                              "v-icon",
                              { staticStyle: { "margin-right": "5px" } },
                              [_vm._v("account_circle")]
                            ),
                            _vm._v(
                              "\n          " +
                                _vm._s(_vm.currentUser) +
                                "\n        "
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  : _vm._e()
              ],
              1
            ),
            _c("app-confirmacion", {
              attrs: {
                show: _vm.logoutDialog,
                titulo: "Cerrar Sesión",
                mensaje: "¿Confirma cerrar su sesión?"
              },
              on: {
                modalConfirmationEmit: function($event) {
                  return _vm.logOutCallback($event)
                }
              }
            }),
            _c(
              "div",
              { staticClass: "text-xs-center" },
              [
                _c(
                  "v-dialog",
                  {
                    attrs: { width: "500" },
                    model: {
                      value: _vm.dialogClienteUsuario,
                      callback: function($$v) {
                        _vm.dialogClienteUsuario = $$v
                      },
                      expression: "dialogClienteUsuario"
                    }
                  },
                  [
                    _c(
                      "v-card",
                      [
                        _c(
                          "v-card-title",
                          {
                            staticClass: "headline lighten-2",
                            attrs: { "primary-title": "" }
                          },
                          [_vm._v("Cliente")]
                        ),
                        _c("v-card-text", [
                          _vm._v(
                            "\n            Su sesión de trabajo esta asociada al cliente\n            " +
                              _vm._s(_vm.nombreCliente) +
                              "\n          "
                          )
                        ]),
                        _c("v-divider"),
                        _c(
                          "v-card-actions",
                          [
                            _c("v-spacer"),
                            _c(
                              "v-btn",
                              {
                                attrs: { color: "primary", flat: "" },
                                on: {
                                  click: function($event) {
                                    _vm.dialogClienteUsuario = false
                                  }
                                }
                              },
                              [_vm._v("Aceptar")]
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _c("app-notificaciones-alertas", {
              attrs: { show: _vm.showModalAlertas },
              on: {
                modalAsociacionEmit: function($event) {
                  return _vm.alertaModalCallback($event)
                }
              }
            }),
            _c("app-change-pass", {
              attrs: {
                show: _vm.showModalPass,
                primerIngreso: _vm.primerIngreso
              },
              on: {
                modalAsociacionEmit: function($event) {
                  return _vm.moduloCallback($event)
                }
              }
            }),
            _c("app-contacto-ejecutivo", {
              attrs: { show: _vm.showModalEjecutivo },
              on: {
                modalContactoEjecutivoEmit: function($event) {
                  return _vm.moduloCallbackEjecutivo($event)
                }
              }
            })
          ],
          1
        )
      : _c(
          "div",
          { attrs: { fixed: "" } },
          [
            _c("VerDetalleModalTab", {
              attrs: {
                unidadVehiculo: _vm.vehiculo ? _vm.vehiculo.unidad : ""
              },
              on: { cerrar: _vm.handleCerrarVerDetalle }
            })
          ],
          1
        )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }